import { translate } from "./translation";

declare var $;

export enum ToastOptionsType {
    note = "note",
    success = "success",
    info = "info",
    warning = "warning",
    danger = "danger",
}

const icons = {
    note: "quote-left",
    success: "check",
    info: "info",
    warning: "exclamation",
    danger: "bug",
}

export enum ToastOptionsGravity {
    top = "top",
    center = "center",
    bottom = "bottom",
}

export enum ToastOptionsPosition {
    left = "left",
    center = "center",
    right = "right",
}

export interface ToastOptions {
    type?: ToastOptionsType
    title?: string
    text?: string
    gravity?: ToastOptionsGravity
    position?: ToastOptionsPosition
    duration?: number
    destination?: string
    newWindow?: boolean
    closable?: boolean
    maxItems?: number
    onClick?: (event: any) => void,
}

const defaultOptions: ToastOptions = {
    type: ToastOptionsType.info,
    title: "Note",
    text: null,
    gravity: ToastOptionsGravity.bottom,
    position: ToastOptionsPosition.center,
    duration: 3000,
    destination: null,
    newWindow: false,
    closable: false,
    maxItems: 1,
    onClick: (event: any) => { },
}

export function createToast (options: ToastOptions) {
    options = { ...defaultOptions, ...options }
    const id = `toast-${Math.floor(Math.random() * 1000000)}-${(new Date()).getTime()}-${Math.floor(Math.random() * 1000000)}-${Math.floor(Math.random() * 1000000)}`;
    let template = `
        <div class="toast toast-${options.type}" role="alert" aria-live="assertive" aria-atomic="true" id="${id}">
            <div class="toast-header">
                <i class="fas fa-${icons[options.type]}"></i>
                <strong class="title">${options.title}</strong>
                ${options.closable ? `
                    <button type="button" class="ml-2 mb-1 close" data-dismiss="toast" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                `: ''}
            </div>
            ${options.text ? `
                <div class="toast-body">
                    ${options.text}
                </div>
            `: ''}
        </div>
    `
    let wrapper = $(`.toast-wrapper-${options.gravity}-${options.position}`)
    if (wrapper.length === 0) {
        wrapper = $('body')
        template = `<div class="toast-wrapper toast-wrapper-${options.gravity}-${options.position}" data-gravity="${options.gravity}" data-position="${options.position}">${template}</div>`
    }
    const toast = $(template)
    if (['top', 'center'].includes(options.gravity)) {
        if (wrapper.find('> .toast').length >= options.maxItems) {
            wrapper.find('> .toast').first().remove();
        }
        wrapper.append(toast);
    } else {
        if (wrapper.find('> .toast').length >= options.maxItems) {
            wrapper.find('> .toast').last().remove();
        }
        wrapper.prepend(toast);
    }
    $(`#${id}`).toast({
        autohide: !options.closable,
        delay: options.duration,
    })
    $(`#${id}`).toast('show')
    $(`#${id}`).on('click', (event: any) => {
        if (options.destination) {
            // create link here...
        } else {
            options.onClick(event)
        }
    })
    const dismiss = () => {
        $(`#${id}`).toast('dispose')
        $(`#${id}`).remove()
    }
    $(`#${id}`).on('hidden.bs.toast', function () {
        dismiss()
    })
    return dismiss
}

function createByType (type: ToastOptionsType, options: ToastOptions) {
    options = {
        ...options, ...{
            type,
        }
    }
    return createToast(options)
}

export function noteToast (options: ToastOptions) {
    return createByType(ToastOptionsType.note, {
        ...{
            title: translate("Note"),
        },
        ...options,
    })
}

export function successToast (options: ToastOptions) {
    return createByType(ToastOptionsType.success, {
        ...{
            title: translate("Success"),
        },
        ...options,
    })
}

export function infoToast (options: ToastOptions) {
    return createByType(ToastOptionsType.info, {
        ...{
            title: translate("Info"),
        },
        ...options,
    })
}

export function warningToast (options: ToastOptions) {
    return createByType(ToastOptionsType.warning, {
        ...{
            title: translate("Warning"),
        },
        ...options,
    })
}

export function dangerToast (options: ToastOptions) {
    return createByType(ToastOptionsType.danger, {
        ...{
            title: translate("Error"),
        },
        ...options,
    })
}
